<template>
  <div class="page-header">
    <v-row align="center">
      <v-col class="pb-0 d-flex align-center">
        <template v-if="breadcrumbs">
          <breadcrumbs :routes="breadcrumbs" />
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" :lg="headerCol">
        <h5 class="text-h5 secondary--font font-weight-large text--primary">
          {{ title }}
        </h5>
      </v-col>
      <slot></slot>
    </v-row>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs.vue";
/**
 * Render the header of the table listing views
 */
export default {
  props: {
    /**
     * View top breadcrumbs navigations to be rendered
     */
    breadcrumbs: {
      type: Array,
    },
    title: { type: String },
    /**
     * Large col value of page title wrapper
     */
    headerCol: { type: [String, Number], default: "" },
  },
  components: {
    Breadcrumbs,
  },
};
</script>
